import React, { Component } from 'react';
import PropTypes from 'prop-types';

import AgGridTableContainer from '../../../table/ag-grid-table-container';
import { reportsCustomGridOptions, TABLE_TYPES } from '../../../table/constants/table-options';
import { formatDate } from '../../../utils/common-utils';

export class DmarcEffectivenessTable extends Component{
    buildColumns = () => {
        const { interval } = this.props;
        return [
            {
                field: 'date',
                headerName: 'Date',
                valueFormatter: ( params ) => formatDate( params.value, interval )
            },
            {
                field: 'blockCount',
                headerName: 'Blocked Messages',
                type: [
                    'numberColumn',
                    'rightAlignColumn'
                ],
            },
            {
                field: 'blockRate',
                headerName: 'Block Rate (% of total msg)',
                type: [
                    'numberColumn',
                    'rightAlignColumn'
                ],
            },
            {
                field: 'deliverCount',
                headerName: 'Delivered Messages',
                type: [
                    'numberColumn',
                    'rightAlignColumn'
                ],
            },
            {
                field: 'deliverRate',
                headerName: 'Deliver Rate (% of total msg)',
                type: [
                    'rateColumn',
                    'rightAlignColumn'
                ],
            },
            {
                field: 'total',
                headerName: 'Total Messages',
                type: [
                    'numberColumn',
                    'rightAlignColumn'
                ],
            }
        ];
    };

    render(){
        const { data, isExportingGridToCSV, exportToCSVSuccess, exportToCSVFailure } = this.props;

        return (
            <AgGridTableContainer
                columnDefs={this.buildColumns()}
                customGridOptions={reportsCustomGridOptions}
                dataAutomationId="reports-dmarc-effectiveness-table"
                exportCSVFileName="DomainProgressB"
                exportToCSVFailure={exportToCSVFailure}
                exportToCSVSuccess={exportToCSVSuccess}
                isExportingGridToCSV={isExportingGridToCSV}
                rowData={data}
                tableType={`${TABLE_TYPES.BASIC} ${TABLE_TYPES.REPORTING}`}
                widgetId="effectiveness"
            />
        );
    };
};

DmarcEffectivenessTable.propTypes = {
    data: PropTypes.array,
    exportToCSVFailure: PropTypes.func,
    exportToCSVSuccess: PropTypes.func,
    interval: PropTypes.string,
    isExportingGridToCSV: PropTypes.bool,
};

export default DmarcEffectivenessTable;
